<template>
    <label class="m-b-0"
           v-bind:style="{'pointer-events':isEnabled?'all':'none'}"
           style="height:35px;padding-top:7px;padding-bottom: 7px;">
        <input type="checkbox"
               :value="dvalue"/> &nbsp;{{label}}
    </label>
</template>
<script>
    import difference from 'lodash.difference';
    import 'jquery.icheck';
    import 'jquery.icheck.css';

    export default {
        name: 'c-checkbox',
        data() {
            return {
                myvalue: this.value
            };
        },
        props: {
            value: {
                requied: true,
                default: function () {
                    return '';
                }
            },
            dvalue: {
                requied: true,
                default: 0
            },
            label: {},
            isEnabled: {
                default: true
            }
        },
        mounted() {
            var vm = this;
            vm.initCheck();
            vm.checkValue();
        },
        methods: {
            initCheck() {
                var vm = this;
                $(vm.$el).find(':checkbox').iCheck({checkboxClass: 'icheckbox_flat-green p-relative'})
                //          .on('ifChecked', function () {
                //            if (vm.myvalue instanceof Array) {
                //              vm.myvalue.push(vm.dvalue);
                //            } else {
                //              vm.myvalue = vm.dvalue;
                //            }
                //          })
                    .on('ifChanged', function () {
                        if ($(this).prop('checked')) {
                            if (vm.myvalue instanceof Array) {
                                vm.myvalue.push(vm.dvalue);
                            } else {
                                vm.myvalue = vm.dvalue;
                            }
                        } else {
                            if (vm.myvalue instanceof Array) {
                                vm.myvalue = difference(vm.myvalue, [vm.dvalue]);
                            } else {
                                vm.myvalue = false;
                            }
                        }
                    })
                    .on('ifClicked', function () {
                        $(this).parent().addClass('focus');
                        $(this).focus();
                    });
            },
            checkValue() {
                var vm = this;
                if (vm.myvalue instanceof Array) {
                    if (vm.myvalue.indexOf(vm.dvalue) > -1) {
                        $(vm.$el).find('input:first').iCheck('check');
                    } else {
                        $(this.$el).find('input:last').iCheck('uncheck');
                    }
                } else {
                    if (vm.myvalue === vm.dvalue)
                        $(vm.$el).find('input:first').iCheck('check');
                    else
                        $(this.$el).find('input:last').iCheck('uncheck');
                }
            }
        },
        watch: {
            'value': function () {
                var vm = this;
                vm.myvalue = vm.value;
            },
            'myvalue': function () {
                var vm = this;
                vm.checkValue();
                vm.$emit('input', vm.myvalue);
            },
            'isEnabled': function () {
                var vm = this;
                if (vm.isEnabled) {
                    $(this.$el).find(':checkbox').iCheck('enable');
                } else {
                    $(this.$el).find(':checkbox').iCheck('disable');
                }
            },
            'dvalue': function () {
                var vm = this;
                vm.checkValue();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// checkbox.vue?ba32a680